import React, { useState } from "react";
import NavigationTextWithIcon from "@src/components/atoms/buttons/navigition-text-with-icon/navigation-text-with-icon";
import organizationActive from "@src/assets/svg/organization-icon-active.svg";
import organizationInactive from "@src/assets/svg/organization-icon-inactive.svg";
import machineGroupsActive from "@src/assets/svg/machine-groups-icon-active.svg";
import machineGroupsInactive from "@src/assets/svg/machine-groups-icon-inactive.svg";
import cleanupActive from "@src/assets/svg/delete-icon-white.svg";
import cleanupInactive from "@src/assets/svg/delete-icon-light-gray.svg";
import styles from "@src/components/molecules/admin-panel-sidebar/admin-panel-sidebar.module.scss";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { useI18N } from "@src/language/language-context";
import { useFeatureFlag } from "@src/hooks/use-feature-flag";
import {
  AdminPanelSidebarItem,
  AdminPanelSidebarProps,
  AdminPanelView,
} from "@src/types/namespace-configuration";
import { RenderIfUserHasMultiplePermissions } from "@src/components/molecules/render-if-user-has-multiple-permissions/render-if-user-has-multiple-permissions";

const cssClassName = "admin-panel-sidebar";

const AdminPanelSidebar = ({ onViewChange }: AdminPanelSidebarProps) => {
  const showGatewayCleanup = useFeatureFlag("show-gateway-cleanup", false);
  const [activeView, setActiveView] = useState<AdminPanelView>("organization");
  const i18n = useI18N();

  const texts = {
    admin: i18n("modules.adminPanelSidebar.admin"),
    organization: i18n("modules.adminPanelSidebar.organization"),
    machineGroups: i18n("modules.adminPanelSidebar.machineGroups"),
    cleanup: i18n("modules.adminPanelSidebar.cleanup"),
    navigationLabel: i18n("modules.adminPanelSidebar.navigationLabel"),
  };

  const allItems: AdminPanelSidebarItem[] = [
    {
      key: "organization",
      label: texts.organization,
      activeIcon: organizationActive,
      inactiveIcon: organizationInactive,
      permission: ["view-organizations"],
    },
    {
      key: "machine-groups",
      label: texts.machineGroups,
      activeIcon: machineGroupsActive,
      inactiveIcon: machineGroupsInactive,
      permission: ["view-machine-groups", "manage-machine-groups"],
    },
    {
      key: "cleanup" as AdminPanelView,
      label: texts.cleanup,
      activeIcon: cleanupActive,
      inactiveIcon: cleanupInactive,
      permission: ["cleanup-gateways"],
    },
  ];
  const NAVBAR_ITEMS = allItems.filter(
    (item) => showGatewayCleanup || item.key !== "cleanup",
  );

  const selectView = (view: AdminPanelView) => {
    setActiveView(view);
    onViewChange?.(view);
  };

  return (
    <aside className={styles[cssClassName]} aria-label={texts.navigationLabel}>
      <FlexColumnContainer>
        <p className={styles[`${cssClassName}__category`]}>{texts.admin}</p>
        {NAVBAR_ITEMS.map((item) => {
          return (
            <RenderIfUserHasMultiplePermissions
              key={item.key}
              permissions={item.permission || []}
            >
              <NavigationTextWithIcon
                label={item.label}
                isActive={activeView === item.key}
                activeIcon={item.activeIcon}
                inActiveIcon={item.inactiveIcon}
                onClick={() => selectView(item.key)}
              />
            </RenderIfUserHasMultiplePermissions>
          );
        })}
      </FlexColumnContainer>
    </aside>
  );
};

export default AdminPanelSidebar;
